module.exports = __webpack_public_path__ + "img/xx.f24500d3.png";